import { render } from "./service-agreement.vue?vue&type=template&id=d88cff22&scoped=true"
import script from "./service-agreement.vue?vue&type=script&lang=js"
export * from "./service-agreement.vue?vue&type=script&lang=js"

import "./service-agreement.vue?vue&type=style&index=0&id=d88cff22&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88cff22"]])

export default __exports__